import { TMachine } from "../../../../common/types";
import DashboardWidget from "../../../../components/Common/dashboard-widget";

interface Props {
    totalCount?: number;
    recentMachines?: TMachine[];
    isLoading?: boolean;
}

const MachinesWidget = ({ totalCount = 0, recentMachines = [], isLoading = false }: Props) => {
    return (
        <DashboardWidget
            title="Machines"
            totalCountDescr="Registered Machines"
            recentCountDescr="New Registrations in the last 30 Days"
            buttonName="Machines List"
            buttonLink="/machines"
            totalCount={totalCount}
            recentCount={recentMachines?.length}
            isLoading={isLoading}
        />
    );
};

export default MachinesWidget;
